import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../core/form/Button';
import Icon from '../../../core/layout/Icon';
import Text from '../../../core/layout/Text';

const FileRepositoryNodeContent = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, justifyContent: 'flex-start' }}>
        {props.item.iconUrl ? (
          <img
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
            src={`${process.env.REACT_APP_FILES_URL}/${props.item.iconUrl}`}
            alt="icon"
          />
        ) : (
          <Icon style={{ fontSize: 20, marginRight: '8px' }} name={props.isAttachment ? 'file' : 'folder'} />
        )}
        <Text value={props.label} maxLength={100} />
      </div>
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
        {!props.isAttachment && !props.hasAttachments ? (
          <span style={{ marginLeft: 10 }}>
            <Button
              icon="plus"
              style={{ marginLeft: 10 }}
              label="Add subcategory"
              onClick={() => props.onAddSubcategory(props.item.id)}
            />
          </span>
        ) : null}
        {!props.isAttachment && !props.hasSubcategories ? (
          <>
            <span style={{ marginLeft: 10 }}>
              <Button icon="file" label="Add file" onClick={() => props.onAddFile(props.item.id)}></Button>
            </span>
            <span style={{ marginLeft: 10 }}>
              <Button icon="paper-clip" label="Add link" onClick={() => props.onAddLink(props.item.id)}></Button>
            </span>
          </>
        ) : null}
        {!props.isAttachment && !props.hasAttachments ? (
          <span style={{ marginLeft: 10 }}>
            <Button
              style={{ marginLeft: 10 }}
              icon="edit"
              tooltip="Edit Category"
              onClick={() => {
                props.onSetIsEditing(props.item);
              }}
            />
          </span>
        ) : null}
        <span style={{ marginLeft: 10 }}>
          <Button
            icon="close-circle"
            tooltip={`Delete ${props.isAttachment ? 'Attachment' : 'Category'}`}
            onClick={() =>
              !props.isAttachment
                ? props.onDeleteCategory({ item: props.item })
                : props.onDeleteAttachment({ item: props.item })
            }
          />
        </span>
      </div>
    </div>
  );
};

FileRepositoryNodeContent.propTypes = {
  label: PropTypes.string.isRequired,
  parentCategoryId: PropTypes.string,
  hasSubcategories: PropTypes.bool,
  hasAttachments: PropTypes.bool,
  isAttachment: PropTypes.bool,
  isEditing: PropTypes.bool,
  item: PropTypes.object.isRequired,
  onAddSubcategory: PropTypes.func.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
  onDeleteCategory: PropTypes.func.isRequired,
  onDeleteAttachment: PropTypes.func.isRequired,
  onAddFile: PropTypes.func.isRequired,
  onAddLink: PropTypes.func.isRequired,
};

export default FileRepositoryNodeContent;
